export default __webpack_public_path__ + "static/planting-ac3403601b76e3181243400d336a40c8.webp";